<script>
import Navbar from "@/components/navbar";
import Layout from "@/layouts/main";
import Read from './board-pages/read.vue';
import Write from './board-pages/write.vue';
import List from './board-pages/list.vue';
import appConfig from "@/app.config";
import axios from 'axios';

export default {
  data() {
    return {
      gr: 0, // 게시판 그룹
      bi: 0, // 게시판 번호
      page: 1, // 페이지 번호
      wi: 0, // 게시물 번호
      work: '', // 작업형태
      searchKeyword: '',
      search: { // 게시판 리스트 조회형식
        nowCnt: 0, // 전체 개수
        totalPages: 1, // 전체 페이지
        perPage: 10, // 페이지당 게시물수
      },
      baseInfo: {},
      thisBoard: {},
      writeData: {},
      replyData: {},
      tableData: [],
      tableDataInfo: {},
      latestData: [],
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      password: "", // 글수정할 때 패스워드
    }
  },
  components: {
    Layout,
    Navbar,
    Read,
    Write,
    List,
  },
  created() {

    // 게시판 리스트에서
    var currentPageReset = true
    // 바로 직전에 게시물읽기 or 삭제  or 수정이었다면
    if (['view', 'modify', 'delete'].includes(this.$store.getters.getNowBoard.work)) {
      // 직전 게시판이 현재 게시판이고 페이지가 1페이지 아니라면
      if (this.bi == this.$store.getters.getNowBoard.idx && this.$store.getters.getNowBoard.page > 1) {
        this.page = this.$store.getters.getNowBoard.page
        currentPageReset = false
      }
    }
    // 현재페이지 초기화
    if (currentPageReset==true) {
      this.search.currentPage = 1
      this.$store.commit('setNowBoard', {
        "idx": 0,
        "page": 0,
        "work": 'list',
      });
    }

    
    if (this.$route.params.group) { this.gr = parseInt(this.$route.params.group) }
    if (this.$route.params.board) { this.bi = parseInt(this.$route.params.board) }
    if (this.$route.params.work) { this.work = this.$route.params.work }
    if (this.$route.params.page) { this.page = parseInt(this.$route.params.page) }
    if (this.$route.params.wi) { this.wi = parseInt(this.$route.params.wi) }
    if (this.$route.params.search) { this.searchKeyword = this.$route.params.search }

    if (this.work=='m' && this.$store.getters.getBoardSecurity.work == 'm' ) {
      this.password = this.$store.getters.getBoardSecurity.password
    }
    if (this.work=='r' && this.$store.getters.getBoardSecurity.work == 'r' ) {
      this.password = this.$store.getters.getBoardSecurity.password
    }

    // work가 r 또는 m 인데 게시판 번호가 없으면 목록으로 이동
    if (['r', 'm'].includes(this.work) && !this.wi) {
      this.$router.push({ path: `/jy/${this.bi}` })
    }
    
    this.first()
  },
  watch: {
    // work가 변경될 때 (게시글 읽기에서 목록으로 돌아올 때) title 복원
    work(newWork) {
      if (newWork !== 'r') {
        // 게시글 읽기가 아닐 때 기본 title로 복원
        document.title = '대구여성인권센터';
      }
    }
  },
  mounted() {
  },
  methods: {
    // 홈페이지 기본정보
    first() {
      // 로그인 사용자 정보
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
      this.boardInfo = this.$store.getters.getWebSiteInfoBoard
      // 게시판 정보 받아오자
      this.jy_board_info()
    },
    // 검색
    submitSearch(value) {
      //this.searchKeyword = value
      //this.jy_board_info()
      this.$router.push({ path: `/jy/${this.bi}/p/0/1/${value}` })
    },
    getCountFromLocal() {
      // 로컬 스토리지에서 조회한 기록이 있는지 확인
      let viewedArticles = JSON.parse(localStorage.getItem('viewedArticles')) || [];
      // 유효하지 않은기간 지정 (삭제될 기간)
      const ONE_DAY = 7 * 24 * 60 * 60 * 1000; // 7일
      //const ONE_DAY = 24 * 60 * 60 * 1000; // 24시간
      //const ONE_DAY = 1 * 60 * 1000; // 1분
      const now = Date.now();
      // 유효하지 않은 기록을 삭제
      viewedArticles = viewedArticles.filter(([bId, aId, timestamp]) => {
        return now - timestamp < ONE_DAY;
      });
      // 기록이 업데이트된 내용을 다시 로컬 스토리지에 저장
      localStorage.setItem('viewedArticles', JSON.stringify(viewedArticles));
      const isViewed = viewedArticles.some(([bId, aId]) => bId === this.bi && aId === this.wi);
      // 이 게시물 조회한 기록이 없으면 로컬 스토리지에 추가
      if (!isViewed) {
        viewedArticles.push([this.bi, this.wi, now]);
        localStorage.setItem('viewedArticles', JSON.stringify(viewedArticles));
      }
      return isViewed
    },
    // 게시판 정보 & 게시물 정보 가져오자
    async jy_board_info() {
      // 게시물 읽기 라면 조회수 부분 처리
      var didCount = false
      if (this.work=='r') {
        // 로컬스토리지에 이 게시물 조회한게 있으면 true반환
        didCount = this.getCountFromLocal()
      }
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/board/jy_board_info',
          headers: {
            "access-token": this.token,
            "login-idx": this.login.idx,
            "password": this.password,
            "level": this.login.level,
          },
          data: {
            "gr": this.gr,
            "bi": this.bi,
            "work": this.work,
            "page": this.page,
            "wi": this.wi,
            "searchKeyword": this.searchKeyword,
            "currentPage": this.page,
            "perPage": this.search.perPage,
            "didCount": didCount,
          },
        })
        .then((res) => {
          if (res.data) {
            if (res.data.status =='success') {
              if (res.data.thisBoard) {
                this.thisBoard = res.data.thisBoard
              }
              if (res.data.writeData) {
                if (res.data.writeData.status) {
                  this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: res.data.writeData.error})
                  this.$router.go(-1);
                }
                this.writeData = res.data.writeData
              }
              if (res.data.replyData) {
                this.replyData = res.data.replyData
              }
              if (res.data.tableData) {
                this.tableData = res.data.tableData
              }
              if (res.data.latestData) {
                this.latestData = res.data.latestData
              }
              if (res.data.tableDataInfo) {
                this.tableDataInfo = res.data.tableDataInfo
                this.search.nowCnt = res.data.tableDataInfo.nowCnt
              }
            } else {
              if (res.data.error) {
                if (res.data.error=='hash could not be identified') {
                  this.$notify({ type: 'error', duration: 3000, 'title': '실패', 'text': "비밀번호가 일치하지 않습니다."})
                } else {
                  this.$notify({ type: 'error', duration: 3000, 'title': '실패', text: res.data.error})
                }
              }
              this.$router.go(-1);
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
          
          if (error.code=='ERR_NETWORK') {
            console.log(error.message)
            this.$notify({ type: 'error', duration: 3000, 'title': '서버오류', text: error.message})
          }
        })
        .finally(()=> {
          // 마무리작업
          // store.js에 있는 setNowBoard 초기화
          this.$store.commit('setBoardSecurity', {
            "work": "",
            "password": "",
          });
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
  }
}
</script>

<template>
  <Layout>
    <Navbar :nav-light="true" />
    <section class="bg-half-2 navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-5"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h3>
                  <span v-if="thisBoard.jsonData">{{ thisBoard.jsonData.name }}</span>
                  <span v-else> - </span>
                </h3>
                <h4>
                  <span v-if="thisBoard.jsonData">{{ thisBoard.jsonData.text }}</span>
                  <span v-else> - </span>
                </h4>
              </div>
              <div class="page-next">
                <nav aria-label="breadcrumb" class="d-inline-block">
                  <ul class="breadcrumb bg-white rounded shadow mb-0">
                    <li class="breadcrumb-item">
                      <router-link to="/">홈</router-link>
                    </li>
                    <li v-if="thisBoard.jsonData" class="breadcrumb-item active" aria-current="page">{{ thisBoard.jsonData.name }}</li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="https://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <section class="section">
      <div class="container" style="min-height:600px">
        <!-- 목록 -->
        <List v-if="work=='' || work=='p'" @submit-search="submitSearch" :latestData="latestData" :searchKeyword="searchKeyword" :page="page" :search="search" :bi="bi" :wi="wi" :boardInfo="boardInfo" :baseInfo="baseInfo" :thisBoard="thisBoard" :tableData="tableData" :tableDataInfo="tableDataInfo"></List>
        <!-- 읽기 -->
        <Read v-if="work=='r'" :bi="bi" :wi="wi" :latestData="latestData" :boardInfo="boardInfo" :baseInfo="baseInfo" :thisBoard="thisBoard" :writeData="writeData" :replyData="replyData"></Read>
        <!-- 쓰기 -->
        <Write v-if="work=='w'" :bi="bi" :wi="wi" :work="work" :boardInfo="boardInfo" :baseInfo="baseInfo" :thisBoard="thisBoard" :writeData="writeData"></Write>
        <!-- 수정 -->
        <Write v-if="work=='m'" :bi="bi" :wi="wi" :work="work" :boardInfo="boardInfo" :baseInfo="baseInfo" :thisBoard="thisBoard" :writeData="writeData"></Write>
      </div>
    </section>
  </Layout>
</template>
